import { Component } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent {
    private deleting: boolean = false;
    private loading: boolean = true;
    private error: string = '';
    private flyerId: string;
    public constructor(private http: Http, private route: ActivatedRoute, private router: Router) {
        this.flyerId = this.route.snapshot.params['id'];
    }

    public isLoading(isLoading) {
        this.loading = isLoading.loading;
        this.error = isLoading.error;
    }

    public deleteFlyer(): void {
        this.deleting = true;
        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.delete(environment.endpoint+'/delete/' + this.flyerId, {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status === 'OK')
                        this.router.navigate(['/dashboard']);
                    else
                        alert(res.results);
                    this.deleting = false;
                },
                err => { this.deleting = false; alert(err); }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/view/view.component.ts